// We're simply an alias for src/uri.js
module.exports = exports = require('./src/uri.js');